import { render, staticRenderFns } from "./bili_table.vue?vue&type=template&id=0495a027"
import script from "./bili_table.vue?vue&type=script&lang=js"
export * from "./bili_table.vue?vue&type=script&lang=js"
import style0 from "./bili_table.vue?vue&type=style&index=0&id=0495a027&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports